import { times } from "lodash";

import {
  ResourceCardSkeleton,
  ResourceCardsContainer,
} from "src/base-components/ResourceCard";

export const FlowListSkeletonV2: React.FC<{
  skeletonCount?: number;
}> = ({ skeletonCount = 7 }) => {
  return (
    <ResourceCardsContainer>
      {times(skeletonCount, (i) => (
        <ResourceCardSkeleton key={i} />
      ))}
    </ResourceCardsContainer>
  );
};
